import { createContext } from 'react';

export interface IndexContextProps {
  config?: any;
  expo?: any;
  menu?: any;
  menuCurrent?: any;
  menuParent?: any;
}

export interface IProps {
  children: JSX.Element;
  value: IndexContextProps;
}

export const IndexContext = createContext<IndexContextProps>({} as IndexContextProps);

export const IndexContextProvider = ({ children, value }: IProps): JSX.Element => {
  return (
    <IndexContext.Provider
      value={{
        config: value?.config,
        expo: value?.expo,
        menu: value?.menu,
        menuCurrent: value?.menuCurrent,
        menuParent: value?.menuParent,
      }}
    >
      {children}
    </IndexContext.Provider>
  );
};
